import { api } from "@/utils/api";

export interface Department {
  id: string;
  companyId: string;
  code: string;
  name: string;
  description?: string | null;
  capacity: number;
  isActive: boolean;
}

export interface DepartmentCreate {
  code: string;
  name: string;
  description?: string | null;
  capacity: number;
  isActive?: boolean;
}

export interface DepartmentUpdate {
  code?: string;
  name?: string;
  description?: string | null;
  capacity?: number;
  isActive?: boolean;
}

export const departmentApi = {
  getAll: async (includeInactive = false) => {
    const response = await api.get<Department[]>("/api/departments/", {
      params: { includeInactive },
    });
    return response.data;
  },

  getById: async (id: string) => {
    const response = await api.get<Department>(`/api/departments/${id}/`);
    return response.data;
  },

  create: async (data: DepartmentCreate) => {
    const response = await api.post<Department>("/api/departments/", data);
    return response.data;
  },

  update: async (id: string, data: DepartmentUpdate) => {
    const response = await api.put<Department>(`/api/departments/${id}/`, data);
    return response.data;
  },

  delete: async (id: string) => {
    const response = await api.delete(`/api/departments/${id}/`);
    return response.data;
  },
};